<template>
  <!-- 工作流明细弹窗 -->
  <a-modal :title="`工作流明细 - ${wristbandName || ''}`" :visible="visible" @cancel="handleClose" :width="1200"
    :footer="null">
    <!-- 条件搜索区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <!-- 收起状态 -->
          <template v-if="!expandSearch">
            <a-col :md="8" :sm="24">
              <a-form-item label="任务序号">
                <a-input-number v-model:value="queryParam.taskNumber" placeholder="请输入任务序号" :min="1" allow-clear
                  class="no-border-radius-input-number" />
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="空间名称">
                <a-input v-model:value="queryParam.spaceName" placeholder="请输入空间名称" allow-clear
                  class="no-border-radius-input" />
              </a-form-item>
            </a-col>
            <!-- 收起状态下的按钮 -->
            <a-col :md="8" :sm="24">
              <a-form-item>
                <span class="table-page-search-submitButtons">
                  <a-button type="primary" @click="handleQuery" class="search-button">
                    搜索
                  </a-button>
                  <a-button style="margin-left: 8px" @click="handleReset" class="no-border-button reset-button">
                    重置
                  </a-button>
                  <a-button style="margin-left: 8px" @click="toggleExpandSearch" class="no-border-button toggle-button">
                    展开
                    <a-icon type="down" />
                  </a-button>
                </span>
              </a-form-item>
            </a-col>
          </template>

          <!-- 展开状态 -->
          <template v-else>
            <!-- 第一行 -->
            <a-col :md="8" :sm="24">
              <a-form-item label="任务序号">
                <a-input-number v-model:value="queryParam.taskNumber" placeholder="请输入任务序号" :min="1" allow-clear
                  class="no-border-radius-input-number" />
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="空间名称">
                <a-input v-model:value="queryParam.spaceName" placeholder="请输入空间名称" allow-clear
                  class="no-border-radius-input" />
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="服务时间">
                <a-input-number v-model:value="queryParam.serviceMinutes" placeholder="请输入服务时间(分钟)" :min="0" :step="1"
                  allow-clear class="no-border-radius-input-number" />
              </a-form-item>
            </a-col>

            <!-- 第二行：按钮行 -->
            <a-col :md="8" :sm="24"></a-col>
            <a-col :md="8" :sm="24"></a-col>
            <a-col :md="8" :sm="24">
              <a-form-item>
                <span class="table-page-search-submitButtons">
                  <a-button type="primary" @click="handleQuery" class="search-button">
                    搜索
                  </a-button>
                  <a-button style="margin-left: 8px" @click="handleReset" class="no-border-button reset-button">
                    重置
                  </a-button>
                  <a-button style="margin-left: 8px" @click="toggleExpandSearch" class="no-border-button toggle-button">
                    收起
                    <a-icon type="up" />
                  </a-button>
                </span>
              </a-form-item>
            </a-col>
          </template>
        </a-row>
      </a-form>
    </div>
    <!-- 操作按钮区域 -->
    <div class="table-operations">
      <a-button type="text" shape="circle" @click="handleRefresh" v-hasPermi="refreshPermission"
        class="refresh-icon-button">
        <img src="@/assets/images/projectUser/refresh.png" alt="刷新" />
      </a-button>
      <a-button type="primary" @click="handleAdd" v-hasPermi="addPermission" class="add-button">
        <a-icon type="plus" />新增
      </a-button>
      <a-button @click="handleImport" v-hasPermi="importPermission" class="no-border-button import-button">
        <a-icon type="import" />导入
      </a-button>

      <a-button @click="handleWorkflowConversion" v-hasPermi="workflowConversionPermission"
        class="no-border-button import-button">
        <a-icon type="swap" />工作流转换
      </a-button>
      <a-button :disabled="multiple" @click="handleDelete" v-hasPermi="removePermission" class="no-border-button">
        <DeleteOutlined />删除
      </a-button>
      <a-button @click="handleDownloadTemplate" v-hasPermi="['system:wristband:importWorkflowTemplate']"
        class="no-border-button workflow-detail-template-download-button">
        <CloudDownloadOutlined />导入模板下载
      </a-button>
    </div>
    <!-- 数据表格 -->
    <div v-if="list && list.length > 0">
      <a-table :columns="tableColumns" :data-source="list" :pagination="false" :loading="loading" :row-selection="{
        selectedRowKeys: selectedRowKeys,
        onChange: onSelectChange,
      }" rowKey="id" class="optimized-table" @change="handleTableChange">
        <!-- 操作列 -->
        <template #action="{ record }">
          <div class="table-action-buttons">
            <a @click="handleEdit(record)" v-hasPermi="editPermission" class="edit-link">
              编辑
            </a>
            <span class="action-divider" v-hasPermi="editPermission">|</span>
            <a @click="handleDelete(record)" v-hasPermi="removePermission" class="delete-link">
              删除
            </a>
          </div>
        </template>
      </a-table>

      <!-- 分页组件 -->
      <div class="pagination-wrapper">
        <div class="pagination-left">
          <span class="pagination-info">
            显示第 {{ (pagination.current - 1) * pagination.pageSize + 1 }} 到第 {{ Math.min(pagination.current *
              pagination.pageSize, pagination.total) }} 条数据/共 {{ pagination.total }} 条
          </span>
          <a-select v-model:value="pagination.pageSize" style="width: 100px; margin-left: 8px" @change="onShowSizeChange"
            class="no-border-radius-select">
            <a-select-option :value="10">10条/页</a-select-option>
            <a-select-option :value="20">20条/页</a-select-option>
            <a-select-option :value="50">50条/页</a-select-option>
            <a-select-option :value="100">100条/页</a-select-option>
          </a-select>
        </div>
        <div class="pagination-right">
          <a-pagination :current="pagination.current" :total="pagination.total" :page-size="pagination.pageSize"
            :show-total="false" @change="changeSize" />
          <span class="pagination-jump">
            到第
            <a-input-number v-model:value="jumpPage" :min="1" :max="Math.ceil(pagination.total / pagination.pageSize)"
              style="width: 60px; margin: 0 4px" @pressEnter="handleJumpPage" class="no-border-radius-input-number" />
            页
          </span>
        </div>
      </div>
    </div>
    <!-- 空数据提示 -->
    <a-empty v-else description="暂无工作流明细数据" style="padding: 60px 0" />
    <!-- 新增/编辑表单 -->
    <workflow-create-form ref="workflowCreateForm" @ok="getList" />
    <!-- 导入组件 -->
    <workflow-import ref="workflowImport" @ok="getList" />
    <!-- 工作流转换弹窗 -->
    <workflow-conversion-modal :visible="workflowConversionVisible" :wristband-id="wristbandId"
      :current-workflow-type="wristbandWorkflowType" @confirm="handleWorkflowConversionConfirm"
      @cancel="handleWorkflowConversionCancel" />
  </a-modal>
</template>

<script>
import { $on, $off, $once, $emit } from '../../../../utils/gogocodeTransfer'
/**
 * 手环工作流明细组件
 * 功能：显示指定手环的工作流明细记录
 * - 支持按空间名称、任务序号筛选明细
 * - 支持分页查询和刷新
 * - 支持导出明细数据
 * - 通过props接收手环ID和名称
 */
import {
  pageWristbandWorkflow,
  delWristbandWorkflow,
} from '@/api/system/wristbandWorkflow'
import { tableMixin } from '@/store/table-mixin'
import WorkflowCreateForm from './WorkflowCreateForm'
import WorkflowImport from './WorkflowImport'
import WorkflowConversionModal from './WorkflowConversionModal'
import { UploadOutlined, DeleteOutlined, CloudDownloadOutlined } from '@ant-design/icons-vue'

export default {
  name: 'WorkflowDetail',
  mixins: [tableMixin],
  components: {
    WorkflowCreateForm,
    WorkflowImport,
    WorkflowConversionModal,
    UploadOutlined,
    DeleteOutlined,
    CloudDownloadOutlined,
  },
  props: {
    // 弹窗显示/隐藏状态
    visible: {
      type: Boolean,
      default: false,
    },
    // 手环ID（必填）
    wristbandId: {
      type: Number,
      default: null,
    },
    // 岗位名称（用于显示在标题中）
    wristbandName: {
      type: String,
      default: '',
    },
    // 手环工作流类型（0-AI工作流，1-顺序工作流，2-灵活工作流）
    wristbandWorkflowType: {
      type: [Number, String],
      default: null,
    },
    // 权限前缀，用于动态生成权限值
    permissionPrefix: {
      type: String,
      default: 'system:wristbandWorkflow',
    },
  },
  data() {
    return {
      // 工作流明细列表数据
      list: [],
      // 加载状态
      loading: false,
      // 选中的行key数组
      selectedRowKeys: [],
      // 选中的行数据数组
      selectedRows: [],
      // 筛选项展开/收起状态（默认收起，只显示前两个筛选项）
      expandSearch: false,
      // 工作流转换弹窗相关
      workflowConversionVisible: false, // 工作流转换弹窗显示状态
      // 查询参数（与表格列字段保持一致）
      queryParam: {
        spaceName: undefined, // 空间名称
        taskNumber: undefined, // 任务序号
        serviceMinutes: undefined, // 服务分钟
      },
      // 分页配置
      pagination: {
        current: 1, // 当前页码
        pageSize: 10, // 每页条数
        total: 0, // 总条数
      },
      // 分页跳转
      jumpPage: 1,
      // 表格列配置
      columns: [
        // {
        //   title: '序号',
        //   dataIndex: 'id',
        //   align: 'center',
        //   width: 80,
        //   scopedSlots: { customRender: 'index' }
        // },
        {
          title: '任务序号',
          dataIndex: 'taskNumber',
          align: 'center',
          width: 100,
        },
        {
          title: '空间名称',
          dataIndex: 'spaceName',
          align: 'center',
          ellipsis: {
            showTitle: true,
          },
          width: 150,
        },
        {
          title: '服务时间(分钟)',
          dataIndex: 'serviceMinutes',
          align: 'center',
          width: 100,
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          width: 150,
          fixed: 'right',
          slots: { customRender: 'action' },
        },
      ],
    }
  },
  computed: {
    /**
     * 刷新权限
     * 根据权限前缀动态生成刷新权限值
     */
    refreshPermission() {
      return ['system:wristbandWorkflow:refresh']
    },
    /**
     * 新增权限
     * 根据权限前缀动态生成新增权限值
     */
    addPermission() {
      return ['system:wristbandWorkflow:add']
    },
    /**
     * 导入权限
     * 根据权限前缀动态生成导入权限值
     */
    importPermission() {
      return [`system:wristband:importWorkflow`]
    },
    /**
     * 删除权限
     * 根据权限前缀动态生成删除权限值
     */
    removePermission() {
      return ['system:wristbandWorkflow:remove']
    },

    editPermission() {
      return ['system:wristbandWorkflow:edit']
    },

    /**
     * 导出权限
     * 根据权限前缀动态生成导出权限值
     */
    exportPermission() {
      return [`system:wristband:exportWorkflow`]
    },
    /**
     * 工作流转换权限
     * 根据权限前缀动态生成工作流转换权限值
     */
    workflowConversionPermission() {
      return ['system:wristbandWorkflow:convert']
    },
    /**
     * 表格列配置（使用 computed 以便在 customRender 中访问 this）
     */
    tableColumns() {
      const that = this
      return [
        // {
        //   title: '序号',
        //   dataIndex: 'id',
        //   width: 80,
        //   align: 'center',
        //   customRender: ({ index }) => {
        //     const current = that.pagination.current || 1
        //     const pageSize = that.pagination.pageSize || 10
        //     const currentIndex = (index !== undefined && index !== null) ? Number(index) : 0
        //     if (isNaN(currentIndex) || isNaN(current) || isNaN(pageSize)) {
        //       return currentIndex + 1
        //     }
        //     return (current - 1) * pageSize + currentIndex + 1
        //   },
        // },
        ...this.columns, // 保留其他列配置
      ]
    },
    /**
     * 是否禁用批量操作（删除）
     * 当没有选中数据时禁用
     */
    multiple() {
      return !this.selectedRowKeys || this.selectedRowKeys.length === 0
    },
  },
  watch: {
    /**
     * 监听弹窗显示状态
     * 当弹窗打开且手环ID存在时，初始化数据
     */
    visible(newVal) {
      if (newVal && this.wristbandId) {
        this.init()
      }
    },
    /**
     * 监听手环ID变化
     * 当手环ID变化且弹窗打开时，重新初始化数据
     */
    wristbandId(newVal) {
      if (newVal && this.visible) {
        this.init()
      }
    },
  },
  methods: {
    handleEdit(record) {
      this.$refs.workflowCreateForm.handleUpdate(record)
    },
    /**
     * 初始化数据
     * 重置分页、清空列表、重置查询条件，然后获取明细列表
     */
    init() {
      // 重置分页到第一页
      this.pagination.current = 1
      this.pagination.total = 0
      this.jumpPage = 1
      // 清空列表数据
      this.list = []
      // 清空选中状态
      this.selectedRowKeys = []
      this.selectedRows = []
      // 重置查询条件
      this.queryParam = {
        spaceName: undefined,
        taskNumber: undefined,
        serviceMinutes: undefined,
      }
      // 获取明细列表
      this.getList()
    },

    /**
     * 获取工作流明细列表
     * 根据手环ID和查询条件分页查询明细数据
     */
    getList() {
      // 校验手环ID
      if (!this.wristbandId) {
        this.$message.warning('手环ID不能为空', 3)
        return
      }

      // 开始加载
      this.loading = true

      // 构建请求参数（与表格列字段保持一致）
      const params = {
        wristbandId: this.wristbandId, // 手环ID
        pageNum: this.pagination.current, // 当前页码
        pageSize: this.pagination.pageSize, // 每页条数
        spaceName: this.queryParam.spaceName, // 空间名称
        taskNumber: this.queryParam.taskNumber, // 任务序号
        serviceMinutes: this.queryParam.serviceMinutes, // 服务分钟
      }

      // 移除空值参数，避免传递无效参数
      Object.keys(params).forEach((key) => {
        if (
          params[key] === undefined ||
          params[key] === null ||
          params[key] === ''
        ) {
          delete params[key]
        }
      })

      // 发送请求
      pageWristbandWorkflow(params)
        .then((response) => {
          // 设置列表数据和总数
          this.list = response.data.records || []
          this.pagination.total = response.data.total || 0
          this.loading = false
        })
        .catch(() => {
          // 请求失败，清空数据
          this.loading = false
          this.list = []
          this.pagination.total = 0
        })
    },

    /**
     * 查询操作
     * 重置到第一页并重新获取列表
     */
    handleQuery() {
      this.pagination.current = 1
      this.getList()
    },

    /**
     * 重置查询条件
     * 清空所有查询条件，重置到第一页并重新获取列表
     */
    handleReset() {
      // 重置查询条件
      this.queryParam = {
        spaceName: undefined,
        taskNumber: undefined,
        serviceMinutes: undefined,
      }
      // 重置到第一页
      this.pagination.current = 1
      this.jumpPage = 1
      // 重新获取列表
      this.getList()
    },

    /**
     * 刷新列表
     * 重新获取当前条件下的明细列表
     */
    handleRefresh() {
      this.getList()
    },
    /**
     * 切换每页条数
     * 重置到第一页并重新查询
     * @param {Number} pageSize - 每页条数
     */
    onShowSizeChange(pageSize) {
      this.pagination.pageSize = pageSize
      this.pagination.current = 1
      this.jumpPage = 1
      this.onSelectChange([], [])
      this.getList()
    },
    /**
     * 分页页码变化
     * @param {Number} current - 当前页
     * @param {Number} pageSize - 每页条数
     */
    changeSize(current, pageSize) {
      this.pagination.current = current
      this.pagination.pageSize = pageSize
      this.jumpPage = current
      this.onSelectChange([], [])
      this.getList()
    },
    /**
     * 跳转到指定页
     */
    handleJumpPage() {
      const totalPages = Math.max(
        1,
        Math.ceil((this.pagination.total || 0) / (this.pagination.pageSize || 10))
      )
      const targetPage = Number(this.jumpPage)
      if (!targetPage || Number.isNaN(targetPage)) {
        this.jumpPage = this.pagination.current
        return
      }
      this.pagination.current = Math.min(Math.max(targetPage, 1), totalPages)
      this.jumpPage = this.pagination.current
      this.onSelectChange([], [])
      this.getList()
    },
    /**
     * 切换筛选项展开/收起状态
     * 控制是否显示额外的筛选项（默认只显示前两个）
     */
    toggleExpandSearch() {
      this.expandSearch = !this.expandSearch
    },

    /**
     * 导出明细数据
     * 支持导出选中数据或当前查询条件下的全部数据
     * - 如果选中了数据，则只导出选中的数据
     * - 如果没有选中数据，则导出当前查询条件下的全部数据
     */
    handleExport() {
      const that = this
      const hasSelection =
        that.selectedRowKeys && that.selectedRowKeys.length > 0
      // 确认对话框
      this.$confirm({
        title: '是否确认导出?',
        content: hasSelection
          ? '将导出所选数据'
          : '将导出当前筛选条件下的全部数据',
        onOk() {
          // 构建导出参数（与表格列字段保持一致）
          const params = {
            wristbandId: that.wristbandId,
            spaceName: that.queryParam.spaceName,
            taskNumber: that.queryParam.taskNumber,
            serviceMinutes: that.queryParam.serviceMinutes,
          }
          // 如果选中了数据，则传递ids参数
          if (hasSelection) {
            params.ids = that.selectedRowKeys
          }
          // 移除空值参数（ids 数组不会被删除）
          Object.keys(params).forEach((key) => {
            if (
              params[key] === undefined ||
              params[key] === null ||
              params[key] === ''
            ) {
              delete params[key]
            }
          })
          // 下载文件
          that.download(
            'system/wristband-workflow/export',
            params,
            `工作流明细_${that.wristbandName}_${new Date().getTime()}.xlsx`
          )
        },
        onCancel() { },
      })
    },

    /**
     * 关闭弹窗
     * 触发close事件，通知父组件关闭弹窗
     */
    handleClose() {
      $emit(this, 'close')
    },

    /**
     * 多选变化处理
     * 更新选中的行key和行数据
     * @param {Array} selectedRowKeys - 选中的行key数组
     * @param {Array} selectedRows - 选中的行数据数组
     */
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },

    /**
     * 表格变化处理
     * 处理分页变化（页码、每页条数）
     * @param {Object} pagination - 分页对象
     */
    handleTableChange(pagination) {
      // 更新分页信息
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      // 分页变化时清空选择
      this.onSelectChange([], [])
      // 重新获取列表
      this.getList()
    },

    /**
     * 新增工作流明细
     * 打开新增表单，自动填充手环ID
     */
    handleAdd() {
      const projectId = this.$store?.getters?.currentProjectId
      if (!projectId) {
        this.$message.warning('请先选择项目', 3)
        return
      }
      if (!this.wristbandId) {
        this.$message.warning('手环ID不能为空', 3)
        return
      }
      // 打开新增表单，并传递手环ID
      this.$refs.workflowCreateForm.handleAdd(this.wristbandId)
    },

    /**
     * 导入工作流明细
     * 打开导入弹窗
     */
    handleImport() {
      if (!this.wristbandId) {
        this.$message.warning('手环ID不能为空', 3)
        return
      }
      // 打开导入弹窗，并传递手环ID
      this.$refs.workflowImport.importExcelHandleOpen(this.wristbandId)
    },

    /**
     * 工作流转换操作
     * 打开工作流转换弹窗
     */
    handleWorkflowConversion() {
      // 检查手环ID
      if (!this.wristbandId) {
        this.$message.warning('手环ID不能为空', 3)
        return
      }
      // 打开弹窗
      this.workflowConversionVisible = true
    },

    /**
     * 工作流转换确认
     * 组件在接口调用成功后会回调此方法，执行后续刷新逻辑
     * @param {Object} payload - 组件回调的信息
     */
    handleWorkflowConversionConfirm(payload = {}) {
      // 关闭工作流转换弹窗
      this.workflowConversionVisible = false
      // 清空选择
      this.onSelectChange([], [])
      // 发出事件通知父组件关闭弹窗并刷新列表
      $emit(this, 'workflow-conversion', {
        wristbandId: payload.wristbandId,
        workflowType: payload.workflowType,
      })
      // 关闭当前弹窗（WorkflowDetail弹窗）
      $emit(this, 'close')
    },

    /**
     * 工作流转换取消
     * 关闭弹窗
     */
    handleWorkflowConversionCancel() {
      this.workflowConversionVisible = false
    },

    /**
     * 删除工作流明细
     * 批量删除选中的工作流明细
     */
    handleDelete() {
      if (!this.selectedRowKeys || this.selectedRowKeys.length === 0) {
        this.$message.warning('请先选择需要删除的数据', 3)
        return
      }
      const that = this
      const ids = this.selectedRowKeys
      this.$confirm({
        title: '确认删除所选中数据?',
        content: `当前选中 ${ids.length} 条数据`,
        onOk() {
          // 构建删除参数
          const data = ids.map((id) => ({ id }))
          return delWristbandWorkflow(data)
            .then(() => {
              that.$message.success('删除成功', 3)
              that.onSelectChange([], [])
              that.getList()
            })
            .catch(() => {
              that.$message.error('删除失败', 3)
            })
        },
        onCancel() { },
      })
    },

    /**
     * 下载工作流明细导入模板
     */
    handleDownloadTemplate() {
      this.download(
        'system/wristband-workflow/importTemplate',
        {},
        `工作流明细导入模板_${new Date().getTime()}.xls`
      )
    },
  },
  emits: ['close', 'workflow-conversion'],
}
</script>

<style scoped>
/* 搜索栏样式 */
.table-page-search-wrapper {
  margin-bottom: 20px;
}

/* 条件搜索区域 label 样式 */
.table-page-search-wrapper :deep(.ant-form-item-label) {
  width: 90px;
  min-width: 90px;
  padding-right: 12px;
  flex: 0 0 90px;
}

.table-page-search-wrapper :deep(.ant-form-item-label > label) {
  width: 90px;
  text-align: right;
  white-space: nowrap;
}

/* 移除所有输入框圆角的通用样式 */
.no-border-radius-input :deep(.ant-input) {
  border-radius: 0 !important;
}

.no-border-radius-input :deep(.ant-input-affix-wrapper) {
  border-radius: 0 !important;
}

.no-border-radius-picker :deep(.ant-picker) {
  border-radius: 0 !important;
}

.no-border-radius-select :deep(.ant-select-selector) {
  border-radius: 0 !important;
}

.no-border-radius-input-number :deep(.ant-input-number) {
  border-radius: 0 !important;
}

.no-border-radius-input-number :deep(.ant-input-number-input) {
  border-radius: 0 !important;
}

/* 搜索区域输入框样式覆盖 */
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input),
.table-page-search-wrapper :deep(.ant-form-item-control-input .ant-input) {
  width: 220px !important;
  background: #FFFFFF !important;
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
}

/* 带前缀/后缀的输入框外层样式 */
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper) {
  width: 220px !important;
  background: #FFFFFF !important;
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
}

/* 带前缀/后缀的输入框内部input去掉边框，避免嵌套 */
.table-page-search-wrapper :deep(.ant-input-affix-wrapper .ant-input) {
  border: none !important;
  background: transparent !important;
  box-shadow: none !important;
}

/* 日期选择器样式 */
.table-page-search-wrapper :deep(.no-border-radius-picker .ant-picker),
.table-page-search-wrapper :deep(.ant-picker) {
  width: 220px !important;
  background: #FFFFFF !important;
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
}

/* 下拉选择框样式 */
.table-page-search-wrapper :deep(.no-border-radius-select .ant-select-selector),
.table-page-search-wrapper :deep(.ant-select-selector) {
  width: 220px !important;
  background: #FFFFFF !important;
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
}

/* 搜索区域数字输入框样式 */
.table-page-search-wrapper :deep(.no-border-radius-input-number.ant-input-number),
.table-page-search-wrapper :deep(.no-border-radius-input-number) {
  width: 220px !important;
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
}

/* 搜索按钮和新增按钮样式 */
.search-button,
.add-button {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
  border-radius: 4px !important;
}

.search-button:hover,
.add-button:hover {
  background-color: #4080ff !important;
  border-color: #4080ff !important;
}

.search-button:focus,
.add-button:focus {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
}

/* 其他按钮圆角设置 */
.table-page-search-wrapper :deep(.ant-btn) {
  border-radius: 4px;
}

/* 按钮区域样式 */
.table-page-search-submitButtons {
  display: flex;
  align-items: center;
  gap: 8px;
}

.table-operations {
  margin-top: 0;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.table-operations :deep(.ant-btn) {
  border-radius: 4px;
}

.refresh-icon-button {
  width: 32px;
  height: 32px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.refresh-icon-button img {
  width: 32px;
  height: 32px;
}

/* 去掉指定按钮的边框 */
.no-border-button {
  border: none !important;
}

.no-border-button:hover,
.no-border-button:focus {
  border: none !important;
}

/* 重置按钮样式 */
.reset-button {
  background: #F3F3F3 !important;
  color: #101010 !important;
}

.reset-button:hover,
.reset-button:focus {
  background: #F3F3F3 !important;
  color: #101010 !important;
}

/* 导入按钮样式 */
.import-button {
  background: #F3F3F3 !important;
  color: #101010 !important;
}

.import-button:hover,
.import-button:focus {
  background: #F3F3F3 !important;
  color: #101010 !important;
}

.import-button :deep(.anticon) {
  color: #101010 !important;
}

.import-button:hover :deep(.anticon),
.import-button:focus :deep(.anticon) {
  color: #101010 !important;
}

/* 展开/收起按钮文字和图标颜色 */
.toggle-button {
  color: #165DFF !important;
}

.toggle-button :deep(.anticon) {
  color: #165DFF !important;
}

.toggle-button:hover,
.toggle-button:focus {
  color: #165DFF !important;
}

.toggle-button:hover :deep(.anticon),
.toggle-button:focus :deep(.anticon) {
  color: #165DFF !important;
}

/* 分页组件样式 */
.pagination-wrapper {
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.pagination-left {
  display: flex;
  align-items: center;
}

.pagination-info {
  color: rgba(0, 0, 0, 0.65);
}

.pagination-right {
  display: flex;
  align-items: center;
  gap: 16px;
}

.pagination-jump {
  display: flex;
  align-items: center;
  color: rgba(0, 0, 0, 0.65);
}

/* 分页组件样式 - 去掉圆角 */
.pagination-wrapper :deep(.ant-btn) {
  border-radius: 0 !important;
}

.pagination-wrapper :deep(.ant-pagination-item) {
  border-radius: 0 !important;
}

.pagination-wrapper :deep(.ant-pagination-prev),
.pagination-wrapper :deep(.ant-pagination-next),
.pagination-wrapper :deep(.ant-pagination-prev .ant-pagination-item-link),
.pagination-wrapper :deep(.ant-pagination-next .ant-pagination-item-link) {
  border-radius: 0 !important;
}

.pagination-wrapper :deep(.ant-pagination-prev button),
.pagination-wrapper :deep(.ant-pagination-next button) {
  border-radius: 0 !important;
}

.pagination-wrapper :deep(.ant-input-number) {
  border-radius: 0 !important;
}

.pagination-wrapper :deep(.ant-input-number-input) {
  border-radius: 0 !important;
}

/* 分页选中页数样式 */
.pagination-wrapper :deep(.ant-pagination-item-active) {
  background: #165DFF !important;
  border-color: #165DFF !important;
  border-radius: 4px !important;
}

.pagination-wrapper :deep(.ant-pagination-item-active a) {
  color: #FFFFFF !important;
}

.pagination-wrapper :deep(.ant-pagination-item-active:hover) {
  background: #165DFF !important;
  border-color: #165DFF !important;
}

.pagination-wrapper :deep(.ant-pagination-item-active:hover a) {
  color: #FFFFFF !important;
}

/* 优化表格样式 */
.optimized-table :deep(.ant-table-thead > tr > th) {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  background-color: #fafafa;
  font-family: PingFang SC, PingFang SC;
  font-weight: bold;
  font-size: 14px;
  color: #333333;
}

.optimized-table :deep(.ant-table-tbody > tr > td) {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 12px 8px;
  font-family: PingFang SC, PingFang SC !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  color: #333333 !important;
}

/* 去掉表格边框 */
:deep(.ant-table) {
  border: none !important;
}

:deep(.ant-table-container) {
  border: none !important;
}

:deep(.ant-table-thead > tr > th) {
  border-bottom: 1px solid #f0f0f0 !important;
  border-right: none !important;
}

:deep(.ant-table-thead > tr > th:first-child) {
  border-left: none !important;
}

:deep(.ant-table-tbody > tr > td) {
  border-bottom: 1px solid #f0f0f0 !important;
  border-right: none !important;
}

:deep(.ant-table-tbody > tr > td:first-child) {
  border-left: none !important;
}

:deep(.ant-table-tbody > tr:last-child > td) {
  border-bottom: none !important;
}

/* 表格滚动条样式优化 */
:deep(.ant-table-body) {
  overflow-x: auto !important;
  scrollbar-width: thin;
  scrollbar-color: #d9d9d9 #f5f5f5;
}

:deep(.ant-table-body::-webkit-scrollbar) {
  height: 8px;
}

:deep(.ant-table-body::-webkit-scrollbar-track) {
  background: #f5f5f5;
  border-radius: 4px;
}

:deep(.ant-table-body::-webkit-scrollbar-thumb) {
  background: #d9d9d9;
  border-radius: 4px;
}

:deep(.ant-table-body::-webkit-scrollbar-thumb:hover) {
  background: #bfbfbf;
}

/* 序号列样式优化 */
:deep(.ant-table-tbody > tr > td:first-child) {
  font-family: PingFang SC, PingFang SC !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  color: #333333 !important;
}

/* 选中的行样式 - 去掉背景色 */
:deep(.ant-table-tbody > tr.ant-table-row-selected > td) {
  background-color: transparent !important;
}

:deep(.ant-table-tbody > tr.ant-table-row-selected:hover > td) {
  background-color: transparent !important;
}

/* 表格复选框样式 */
.optimized-table :deep(.ant-checkbox-inner) {
  width: 16px !important;
  height: 16px !important;
  border-radius: 0 !important;
  border-color: #999999 !important;
}

.optimized-table :deep(.ant-checkbox-checked .ant-checkbox-inner) {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
}

.optimized-table :deep(.ant-checkbox-checked .ant-checkbox-inner::after) {
  border-color: #FFFFFF !important;
}

.optimized-table :deep(.ant-checkbox:hover .ant-checkbox-inner) {
  border-color: #165DFF !important;
}

.optimized-table :deep(.ant-checkbox-input:focus + .ant-checkbox-inner) {
  border-color: #165DFF !important;
}

.optimized-table :deep(.ant-checkbox-checked:hover .ant-checkbox-inner) {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
}

/* 操作列链接样式 */
.table-action-buttons a {
  color: #1890ff;
  cursor: pointer;
  white-space: nowrap;
}

.table-action-buttons a:hover {
  color: #40a9ff;
}

.table-action-buttons .edit-link {
  color: #165DFF !important;
}

.table-action-buttons .edit-link:hover {
  color: #4080ff !important;
}

.table-action-buttons .delete-link {
  font-family: PingFang SC, PingFang SC !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  color: #333333 !important;
}

.table-action-buttons .delete-link:hover {
  color: #333333 !important;
}

.action-divider {
  margin: 0 8px;
  color: #d9d9d9;
  white-space: nowrap;
}

/* 工作流明细下载模板按钮文字和图标颜色 */
.workflow-detail-template-download-button {
  color: #165DFF !important;
}

.workflow-detail-template-download-button :deep(.anticon) {
  color: #165DFF !important;
}

.workflow-detail-template-download-button:hover,
.workflow-detail-template-download-button:focus {
  color: #165DFF !important;
}

.workflow-detail-template-download-button:hover :deep(.anticon),
.workflow-detail-template-download-button:focus :deep(.anticon) {
  color: #165DFF !important;
}
</style>